import { render, staticRenderFns } from "./effective_validation.vue?vue&type=template&id=71128e4a&scoped=true&"
import script from "./effective_validation.vue?vue&type=script&lang=js&"
export * from "./effective_validation.vue?vue&type=script&lang=js&"
import style0 from "./effective_validation.vue?vue&type=style&index=0&id=71128e4a&lang=less&scoped=true&"
import style1 from "./effective_validation.vue?vue&type=style&index=1&id=71128e4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71128e4a",
  null
  
)

export default component.exports